import React from 'react';
import { PropTypes } from 'prop-types';
import { Form, Button, Spinner } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

PasswordRecoveryForm.propTypes = {
    status: PropTypes.string,
    onSubmit: PropTypes.func.isRequired
};

function PasswordRecoveryForm(props) {

    const { submitting } = props;

    const { t } = useTranslation();
    const formik = useFormik({
		initialValues: {
			email: "",
			password: ""
		},
		validationSchema: Yup.object().shape({
			email: Yup.string()
				.email(t('form.email_invalid'))
				.required(t('form.email_required'))
		}),
		enableReinitialize: true,
		onSubmit: values => props.onSubmit(values)
	});
    const { values, errors, touched } = formik;

    return (
        <Form onSubmit={formik.handleSubmit}>
            <Form.Group>
                <Form.Label>{t('general.emailAddress')}</Form.Label>
                <Form.Control
                    type="email"
                    placeholder={t('general.emailAddress')}
                    name="email"
                    value={values.email}
                    onChange={formik.handleChange}
                    autoFocus
                    isInvalid={errors.email && touched.email}
                    disabled={submitting}
                    autoComplete="username"
                />
                {errors.email ? (
                    <Form.Control.Feedback type="invalid">
                        {errors.email}
                    </Form.Control.Feedback>
                ) : null}
            </Form.Group>
            <Form.Group style={{marginTop: '20px'}}>
                <Button type="submit" disabled={submitting}>
                    {t('auth.requestNewPassword')}
                </Button>
                {submitting ?
                    <Spinner animation="border" variant="primary" size="sm" style={{ marginLeft: '10px' }} />
                : null}
            </Form.Group>
        </Form>
    )
}

export default PasswordRecoveryForm;